"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagPromptDelivery = void 0;
const tagPromptDelivery = (tags) => (tags === null || tags === void 0 ? void 0 : tags.some((item) => item === 'Pronta-entrega')) ? 'pronta-entrega' : 'nao-pronta-entrega';
exports.tagPromptDelivery = tagPromptDelivery;
